'use client'

import { useState } from 'react'

interface FaqItem {
  q: string
  a: string
}

interface FaqAccordionProps {
  faqs: FaqItem[]
}

export function FaqAccordion({ faqs }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  return (
    <div className="flex flex-col divide-y" style={{ borderColor: '#222228' }}>
      {faqs.map((faq, i) => {
        const isOpen = openIndex === i
        return (
          <div key={faq.q}>
            <button
              onClick={() => setOpenIndex(isOpen ? null : i)}
              className="w-full flex items-start justify-between gap-6 py-7 text-left group"
              aria-expanded={isOpen}
            >
              <span
                className="text-base leading-snug transition-colors duration-200"
                style={{
                  fontFamily: 'var(--font-syne)',
                  fontWeight: 600,
                  color: isOpen ? '#818CF8' : '#C4C4CF',
                }}
              >
                {faq.q}
              </span>
              <span
                className="shrink-0 mt-0.5 w-5 h-5 flex items-center justify-center rounded-full border transition-all duration-300"
                style={{
                  borderColor: isOpen ? '#818CF8' : '#3F3F46',
                  color: isOpen ? '#818CF8' : '#52525B',
                  transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
                }}
                aria-hidden
              >
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M5 1v8M1 5h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
              </span>
            </button>
            <div
              className="overflow-hidden transition-all duration-300 ease-in-out"
              style={{ maxHeight: isOpen ? '20rem' : '0px', opacity: isOpen ? 1 : 0 }}
            >
              <p
                className="pb-7 text-sm leading-relaxed max-w-2xl"
                style={{ color: '#A1A1AA', fontFamily: 'var(--font-jakarta)' }}
              >
                {faq.a}
              </p>
            </div>
          </div>
        )
      })}
    </div>
  )
}
